import { Nullable } from 'common-types';
import { createStore } from 'store-utils';
import { Recipient } from '../types/notification-settings-types';

const NotificationConfigureStore = createStore<NotificationConfigureStoreState>(
  {
    isModalVisible: false,
    isLoadingTestNotification: false,
    errorMessage: null,
    potentialRecipients: null,
  },
  'Connections Configure Store',
);

interface NotificationConfigureStoreState {
  isModalVisible: boolean;
  isLoadingTestNotification: boolean;
  errorMessage: Nullable<string>;
  potentialRecipients: Nullable<Recipient[]>;
}

export default NotificationConfigureStore;
